/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_Chats_LabelInputs */

const en_mcp_demo_chats_label = /** @type {(inputs: Mcp_Demo_Chats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your chats`)
};

const es_mcp_demo_chats_label = /** @type {(inputs: Mcp_Demo_Chats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus chats`)
};

/**
* | output |
* | --- |
* | "Your chats" |
*
* @param {Mcp_Demo_Chats_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_chats_label = /** @type {((inputs?: Mcp_Demo_Chats_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_Chats_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_chats_label(inputs)
	return en_mcp_demo_chats_label(inputs)
});